import { render, staticRenderFns } from "./AbilityDegree.vue?vue&type=template&id=b0c57d48&scoped=true&"
import script from "./AbilityDegree.vue?vue&type=script&lang=js&"
export * from "./AbilityDegree.vue?vue&type=script&lang=js&"
import style0 from "./AbilityDegree.vue?vue&type=style&index=0&id=b0c57d48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c57d48",
  null
  
)

export default component.exports